import { ReactNode, HTMLAttributes, MutableRefObject, CSSProperties, } from 'react';
import { TabsProps, TabPaneProps } from 'antd/lib/tabs';

export interface LayOutPageProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  tableId?: string;
  bodyClassName?: string;
  bodyStyle?: CSSProperties;
}
/** 左侧只有一列 */
export interface LayOutPageLeftProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  style?: CSSProperties;
}
/** 左侧多列 */
export interface LayOutPageLeftsProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  style?: CSSProperties;
}
/** 左侧多列的每一项 */
export interface LayOutPageLeftItemProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  style?: CSSProperties;
}
/** 左侧多列的常用页面 标题+menuTree */
export interface LayOutPageLeftPageProps {
  className?: string;
  style?: CSSProperties;
  /** 头部类名 */
  headerClassName?: string;
  /** 头部样式 */
  headerStyle?: CSSProperties;
  /** 头部标题 */
  title?: ReactNode;
  /** 头部操作按钮 */
  afterNode?: ReactNode;
  /** body类名 */
  bodyClassName?: string;
  /** body样式 */
  bodyStyle?: CSSProperties;
  /** body内容 */
  bodyNode?: ReactNode;
}
export interface LayOutPageRightProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  style?: CSSProperties;
}

export type LayOutPageHeaderType = 'Tab';
export interface Ibadge {
  show?: boolean;
  fetchApi?: (params?: any) => Promise<any>;
  params?: any;
  formatData?: (data: any) => any;
}

export interface HeaderActionType {
  onRefresh: () => void;
}

export type LayOutPageHeaderActionType = HeaderActionType | undefined;
export interface LayOutPageHeaderProps extends HTMLAttributes<HTMLElement> {
  /** 对象句柄 */
  actionRef?: MutableRefObject<LayOutPageHeaderActionType>;
  /** 类名 */
  className?: string;
  /** 类型 */
  type?: LayOutPageHeaderType;
  /** 字典名称 */
  enumCode?: string;
  /** 是否显示全部 */
  showAll?: boolean;
  /** TabsPops */
  tabsProps?: TabsProps;
  /** TabPaneProps */
  tabPaneData?: TabsProps['items'];
  /** 角标配置 */
  badge?: Ibadge;
  /** 需要过滤掉的tabKey */
  filterTabKeys?: string[];
}

export interface LayOutPageContentProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}
export interface LayOutPageContentHeaderProps {
  className?: string;
  style?: CSSProperties;
  title?: ReactNode;
  operationButton?: ReactNode[];
  children?: ReactNode;
}

export interface LayOutPageFooterProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  style?: CSSProperties;
}

export interface LayOutPageDetailProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  style?: CSSProperties;
  isHide?: boolean;
}

export interface LayOutPageItemProps
  extends LayOutPageLeftProps,
    LayOutPageRightProps,
    LayOutPageHeaderProps,
    LayOutPageContentProps,
    LayOutPageFooterProps,
    LayOutPageDetailProps {}

export interface ILayOutPageInfo {
  /** 左侧节点(单节点) */
  left: ReactNode[];
  /** 左侧节点(多节点) */
  lefts: ReactNode[];
  /** 右侧节点 */
  right: ReactNode[];
  /** 头部节点 */
  header: ReactNode[];
  /** 内容节点 */
  content: ReactNode[];
  /** 底部节点 */
  footer: ReactNode[];
  /** 详情 */
  detail: ReactNode;
}
export interface ILayOutPageLeftsInfo {
  /** item节点 */
  item: ReactNode[];
  /** 标题+menuTree */
  page: ReactNode[];
}
export interface ILayOutPageContentInfo {
  /** 头部 */
  header: ReactNode[];
  /** 内容 */
  content: ReactNode[];
}

export enum LayOutPageItemEnum {
  Left = 'Left',
  Lefts = 'Lefts',
  LeftItem = 'LeftItem',
  LeftPage = 'LeftPage',
  Right = 'Right',
  Header = 'Header',
  Content = 'Content',
  ContentHeader = 'ContentHeader',
  Footer = 'Footer',
  Detail = 'Detail',
}
